import { useState } from 'react'

import Box from '../Box/index'
import styles from './Amenities.module.scss'

const Amenities = ({ data }) => {
  const [isCollapsed, setCollapsed] = useState(true)

  const hasAmenities = Object.keys(data).length

  return (
    <Box
      title="Amenities &amp; services"
      isCollapsed={isCollapsed}
      handleClick={() => setCollapsed(!isCollapsed)}
      isCollapsable={true}
    >
      <div onClick={() => hasAmenities && !isCollapsed && setCollapsed(true)}>
        {hasAmenities ? (
          <>
            {!isCollapsed ? (
              <div className={styles.wrapper}>
                {Object.keys(data).map(key => (
                  <div key={`panel${key}`} className={styles.panel}>
                    <div className={styles.category}>
                      <h3 className={styles.categoryTitle}>{key}</h3>
                      <ul>
                        {data[key].map((amenity, i) => (
                          <li key={amenity + i} className={styles.amenity}>
                            {amenity.name}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className={styles.seeMoreLink}>
                See{' '}
                {Object.keys(data).reduce((prevs, current) => prevs + current.length, 0)}{' '}
                amenities
              </div>
            )}
          </>
        ) : (
          <div>No amenities found</div>
        )}
      </div>
    </Box>
  )
}

export default Amenities
